import { DatePicker, Group } from "react-aria-components";
import styled from "@emotion/styled";
import { MDSButton } from "@/mds/components/buttons/button";

export const StyledDatePicker = styled(DatePicker)``;

export const StyledGroup = styled(Group)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  max-width: 200px;

  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing["0.5"]} ${({ theme }) => theme.spacing["2"]};

  &[data-focus-within] {
    border-color: ${({ theme }) => theme.colors.border.emphasis};
  }
`;

export const LabelWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing["2"]} 0;
`;

export const StyledButton = styled(MDSButton)`
  padding: ${({ theme }) => theme.spacing["2"]};
`;
